export Icon from "./icon";
export colors from "./colors";
export brands from "./brands";
export head from "./head";
export enumWhitelabel from "./enum";
export images from "./images";



// WEBPACK FOOTER //
// ./src/assets/index.js